import { getAllChildrenStrings } from '@repo/contracts/multi-use/structured-content/utils';
import { css, cx } from '@repo/pandacss/styled-system/css';
import { Fragment, type ElementType } from 'react';
import { renderStructuredContent } from '../../rendererContext';
import type { HeadingProps } from './types';

const headingStyleMap: Record<number, string> = {
  1: css({ textStyle: 'title' }),
  2: css({ textStyle: 'textLargeBold' }),
  3: css({ textStyle: 'textLarge' }),
  4: css({ textStyle: 'textBold' }),
  5: css({ textStyle: 'text' }),
  6: css({ textStyle: 'textSmall' }),
};

export function ContentHeading(scProps: HeadingProps) {
  const {
    props: { level, children, rendererProps },
  } = scProps;
  const Component: ElementType = `h${level}`;
  const variant = headingStyleMap[level];

  if (!children || !Component) return;

  const childrenString = getAllChildrenStrings(scProps);
  if (!childrenString) return;
  const anchorLinkId = childrenString
    ? childrenString
        .trim()
        .replace(/\s+/g, '-')
        .replace(/[^a-zA-Z0-9-]/g, '')
        .toLowerCase()
    : '';
  return (
    <Component
      className={cx(
        variant,
        css({
          '& *': {
            fontFamily: '[inherit !important]',
            fontSize: '[inherit !important]',
            lineHeight: '[inherit !important]',
          },
        }),
      )}
      id={anchorLinkId}
    >
      {[children].flat().map((child, idx) => {
        if (typeof child === 'string') {
          return <Fragment key={`content-heading-${idx}`}>{child}</Fragment>;
        }
        return (
          <Fragment key={`content-heading-doc-${idx}`}>
            {renderStructuredContent(child, rendererProps)}
          </Fragment>
        );
      })}
    </Component>
  );
}
